<template>
  <div class="promo-container pb-5">
    <div class="promo-header position-relative text-center mb-4">
      <img
        src="@/assets/img/img-promo-superior.svg"
        class="img-promo-superior img-fluid"
        alt="Promo Superior"
      />

      <div class="">
        <pre class="text-content">
             Adherite al <FONT COLOR="#01477e">Formato Digital</FONT> y
    participá de sorteos por el importe de tu
                   expensa del mes!!
    También podrás recibirla por <FONT COLOR="#01477e">WhatsApp</FONT>
        </pre>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <form
            class="p-4 text-center dualcol-test rounded-form"
            v-on:submit="suscribe"
          >
            <h4 style="color: white" v-if="ownerAssociation">
              {{ ownerAssociation.administration }}
            </h4>

            <div class="help-text text-left my-4 font-weight-bold text-white">
              <div class="mb-2">
                <span>Bienvenido:</span>
                <br />
                <span v-if="ownerAssociation">{{
                  ownerAssociation.functional_unit_owners
                }}</span>
                <br />
                <span v-if="ownerAssociation">{{
                  ownerAssociation.owners_association_name
                }}</span>
              </div>
              <span
                >Estoy de acuerdo con el envío de las expensas por E-mail y/o
                Whatsapp y la cancelación del envío en formato impreso en todas
                mis unidades funcionales.</span
              >
            </div>

            <label class="b-contain mb-2 text-white">
              <span
                >Acepto
                <a
                  id="popup"
                  style="text-decoration: none; color: #ce4169; cursor: pointer"
                  >Terminos y Condiciones</a
                ></span
              >
              <input type="checkbox" v-model="aceptChecked" />
              <div class="b-input"></div>
            </label>

            <div v-if="aceptChecked" class="animate__animated animate__fadeIn">
              <input
                v-if="email_decoded && email_decoded !== 'rellename'"
                type="email"
                class="form-control mb-3"
                disabled
                v-model="datosUser.email"
                placeholder="Aquí escribe tu correo electrónico"
              />
              <input
                v-else
                type="email"
                class="form-control mb-3"
                v-model="datosUser.email"
                placeholder="Aquí escribe tu correo electrónico"
              />

              <div class="input-group has-validation mb-3">
                <input
                  v-if="email_decoded && email_decoded !== 'rellename'"
                  type="email"
                  :class="
                    !emailIguales && datosUser.emailCheck
                      ? 'form-control is-invalid'
                      : 'form-control'
                  "
                  v-model="datosUser.emailCheck"
                  placeholder="Repite tu correo electrónico"
                  disabled
                />
                <input
                  v-else
                  type="email"
                  :class="
                    !emailIguales && datosUser.emailCheck
                      ? 'form-control is-invalid'
                      : 'form-control'
                  "
                  v-model="datosUser.emailCheck"
                  placeholder="Repite tu correo electrónico"
                />
                <div
                  v-if="!emailIguales && datosUser.emailCheck"
                  class="invalid-feedback text-left bg-white p-1 rounded"
                >
                  Los emails no coinciden
                </div>
              </div>

              <input
                type="number"
                id="phone_number"
                v-model="datosUser.phone"
                class="form-control mb-3"
                placeholder="Ingresa tu nro. de celular si deseas recibirlo por Whatsapp"
              />

              <div class="input-group has-validation mb-4">
                <input
                  type="number"
                  :class="
                    !numerosIguales && (datosUser.phone || datosUser.phoneCheck)
                      ? 'form-control is-invalid'
                      : 'form-control'
                  "
                  v-model="datosUser.phoneCheck"
                  placeholder="Repite tu nro. de celular"
                />
                <div
                  v-if="!numerosIguales && datosUser.phoneCheck"
                  class="invalid-feedback text-left bg-white p-1 rounded"
                >
                  Los numeros de teléfonos no coinciden
                </div>
              </div>

              <button
                :disabled="loading || !numerosIguales || !emailIguales"
                type="submit"
                class="btn btn-rounded btn-primary btn-block mb-2"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm ma-auto"
                  role="status"
                ></div>
                <span v-else>ACEPTAR</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPromo',
  props: [],
  data() {
    return {
      datosUser: {
        is_promotional: true,
      },
      aceptChecked: false,
      loading: false,
      ownerAssociation: null,
      email_decoded: null,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    settlementId() {
      return this.$route.params.settlement_id;
    },
    email() {
      return this.$route.params.email;
    },
    emailIguales() {
      if ((this.datosUser.phone === this.datosUser.phoneCheck) && (this.datosUser.phone && this.datosUser.phoneCheck)) return true;
      if ((!this.datosUser.email && !this.datosUser.emailCheck) || (this.datosUser.email == 'rellename')) return false;
      return this.datosUser.email === this.datosUser.emailCheck;
    },
    numerosIguales() {
      if ((this.datosUser.email === this.datosUser.emailCheck) && (this.datosUser.email && this.datosUser.emailCheck)) return true;
      return this.datosUser.phone === this.datosUser.phoneCheck;
    },

    calculateHeight() {
      console.log(this.windowWidth);
      return Number(this.windowWidth) < 480;
    },
  },

  methods: {
    async checkEmail(email) {
      return String(email)
          .toLowerCase()
          .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    async checkQR() {
      await this.checkQRSuscriptorPromo(this.settlementId, this.email).then(async (res) => {
        this.ownerAssociation = res.data;
        this.email_decoded = await res.data.email;

        if (res.data.email != 'rellename') {
          this.datosUser.email = this.email_decoded;
          this.datosUser.emailCheck = this.email_decoded;
        }
      }).catch(() => {
        this.$router.push({ name: 'error-message' });
      });
    },
    suscribe(e) {
      e.preventDefault();
      Object.assign(this.datosUser, this.ownerAssociation);
      if (this.datosUser.email == 'rellename') this.datosUser.email = this.datosUser.emailCheck;

      this.suscribeDigitalExpenses(this.datosUser).then(() => {
        this.$router.push({ name: 'success-message', params: { ownerAssociation: this.ownerAssociation } });
      }).catch(() => {
        this.$swal.fire({
          icon: 'error',
          title: 'Lo sentimos',
          text: 'Hubo un error al realizar la solicitud',
        });
      });
    },
    onResize() {
      this.windowWidth = window.windowWidth;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
   this.checkQR();
    document.getElementById('popup').addEventListener('click', () => {
      this.$swal.fire({
        icon: 'info',
        title: 'Terminos y Condiciones',
        html: `1. ORGANIZADOR: Las presentes bases y condiciones que rigen la
promoción “cambia papel x premios” es organizada por Power Solutions
srl (en adelante “el organizador”), con domicilio en la Avda.
Independencia 903 piso 2 de la ciudad de Mar del Plata.<br><br>
2. ACEPTACIÓN DE LAS BASES: Quienes participan de la promoción, por
su sola participación, declaran conocer y aceptar todos y cada uno de
los términos descriptos en estas bases.
Dichos términos podrán ser modificados por el organizador, sin que ello
implique alterar la esencia de la promoción ni afectar derechos
adquiridos por los participantes. Dichas modificaciones serán publicadas
en el mismo medio que las presentes bases, no siendo alterada la
aceptación previamente brindada por el participante.<br><br>
3. PARTICIPACIÓN: Podrán participar de la promoción, todas las personas
humanas mayores de DIECIOCHO (18) años, que sean copropietarios
de las unidades funcionales que trabajen sobre el sistema IDATA.<br><br>
4. MECÁNICA DE PARTICIPACIÓN:
Para participar, cada persona deberá ingresar en el botón “Adherite” y
confirmar el mail que el sistema tiene registrado, pudiendo agregar un
numero de celular para la recepción de sus expensas también por
WhatsApp. La confirmación final indica la aceptación de no recibir mas
en forma impresa la liquidación de expensas, solo digitalmente por mail
y/o WhatsApp.<br><br>
5. SELECCIÓN DE LOS GANADORES: El día 1 de cada mes se sortea
entre todas las personas que se adhirieron el mes anterior. -El
ORGANIZADOR se comunicará con el copropietario y la administración
de su consorcio para realizar el pago del premio.<br><br>
6. PREMIO: El premio consistirá en el monto resultante del prorrateo de los
gastos comunes del mes de la adhesión de la unidad funcional adherida,
no se incluyen deudas anteriores, punitorios, gastos particulares, fondo,
ni otros tipos de gastos. <br><br>
7. RESPONSABILIDAD: El organizador no será responsable si los datos
de los participantes hubieran sido erróneamente consignados. De igual
manera, el organizador no será responsable de ningún reclamo de
ningún tipo efectuado por terceros que se atribuyan cualquier derecho
de propiedad intelectual o de cualquier naturaleza vinculados con esta
campaña.
El organizador no será responsable por las interrupciones, cortes y/o
cualquier deficiencia que pudiere dificultar el acceso y/o navegación en
aplicaciones para celular ni website de la marca por parte de los
participantes.<br><br>
8. ORGANIZADOR. FACULTADES.
El ORGANIZADOR, sin que ello le genere carga, obligación y/o
responsabilidad alguna podrá:<br><br> a) Modificar las presentes BASES<br><br> b)
solicitar la reválida o rectificación de las adhesiones,<br><br> c) Dejar sin efecto o
suspender esta promoción antes de la notificación a los GANADORES, <br><br>
d) Prorrogar cada uno de los plazos de vigencia y fechas fijadas antes
de la finalización del período de inscripción previsto en estas BASES,<br><br> e)
Modificar la fecha de entrega de los PREMIOS o ejecución de los
mismos, la cual no podrá ser superior a DOCE (12) meses,<br><br> f) Solicitar a
los PARTICIPANTES y/o potenciales GANADORES, en cualquier
momento antes de la finalización de la promoción, que verifiquen sus
datos y/o los corroboren y/o rectifiquen los mismos, así como también
ratifiquen su inscripción.<br><br>
9. JURISDICCIÓN: Para cualquier controversia originada en la presente
campaña regirá la jurisdicción de los Tribunales en lo Contencioso
Administrativo Federal con asiento en la Ciudad de Mar del Plata Aires,
a la que los participantes aceptan someterse voluntariamente,
renunciando a cualquier otro fuero o jurisdicción.`,
        showClass: {
          popup: 'animate__animated animate__fadeIn',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOut',
        },
      });
    });
    this.calculateHeight();
  },
};
</script>
<link href="https://fonts.cdnfonts.com/css/amplesoft-pro" rel="stylesheet"/>
<style lang='scss'>
@import url('https://fonts.cdnfonts.com/css/amplesoft-pro');

pre.text-content {
font-family: 'AmpleSoft Pro', sans-serif !important;
font-size: 1rem;
color: #f2ffff;
white-space: pre-wrap;
text-align: center;
}

@media (min-width: 992px) {
.text-promo-container {
position: absolute;
top: 10%;
right: 10%;
transform: rotate(-3deg);
}
pre.text-content {
font-size: 1.2vw;
}
}

@media (max-width: 991px) {
.text-promo-container {
position: relative;
background-color: #002639;
padding: 15px;
margin-top: -10px;
border-radius: 0 0 15px 15px;
}
pre.text-content {
color: white;
}
}

.expensas-digital {
background-color: #ef5d3c !important;
background-image: linear-gradient(75deg, #ef5d3c 40%, #da198b 75%) !important;
}

.b-contain *, .b-contain *::before, .b-contain *::after {
box-sizing: content-box !important;
}

.b-contain input {
position: absolute;
z-index: -1;
opacity: 0;
}

.b-contain span {
line-height: 1.82;
font-size: 0.9rem;
font-family: inherit;
}

.b-contain {
position: relative;
padding-left: 1.8rem;
cursor: pointer;
margin-bottom: 0.46rem;
display: inline-block;
}

.b-contain input[type="checkbox"] ~ .b-input {
position: absolute;
top: 0;
left: 0;
height: 1.2rem;
width: 1.2rem;
background: rgba(241, 245, 248, 1);
transition: background 250ms;
border: none;
border-radius: 0.2rem;
}

.b-contain input[type="checkbox"] ~ .b-input::after {
content: '';
position: absolute;
display: none;
left: 0.35rem;
top: 0.1rem;
width: 0.30rem;
height: 0.6rem;
border: solid rgba(255, 255, 255, 1);
border-width: 0 4px 4px 0;
transition: background 250ms;
transform: rotate(45deg);
}

.b-contain input:checked ~ .b-input::after {
display: block;
}

.b-contain:hover input ~ .b-input,
.b-contain input:focus ~ .b-input {
background: rgb(231, 238, 243);
}

.b-contain input:focus ~ .b-input {
box-shadow: 0 0 0 2px rgba(206, 65, 105, 0.6);
}

.b-contain input:checked ~ .b-input {
background: rgba(206, 65, 105, 1);
border-color: rgba(206, 65, 105, 1);
}

.b-contain .b-input::before {
content: '';
display: block;
position: absolute;
left: 0;
top: 0;
width: 3rem;
height: 3rem;
margin-left: -0.411rem;
margin-top: -0.411rem;
background: rgba(206, 65, 105, 1);
border-radius: 0.104rem;
opacity: .6;
z-index: 99999;
transform: scale(0);
}

@keyframes b-ripple {
0% { transform: scale(0); }
20% { transform: scale(1); }
100% { opacity: 0; transform: scale(1); }
}

@keyframes b-ripple-duplicate {
0% { transform: scale(0); }
30% { transform: scale(1); }
60% { transform: scale(1); }
100% { opacity: 0; transform: scale(1); }
}

.b-contain input + .b-input::before {
animation: b-ripple 250ms ease-out;
}

.b-contain input:checked + .b-input::before {
animation-name: b-ripple-duplicate;
}

.b-contain .b-input::before {
visibility: hidden;
}

.b-contain input:focus + .b-input::before {
visibility: visible;
}

/* Estilos del formulario */
.dualcol-test {
background: #002639 !important;
-webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
-moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
margin-top: 0 !important;
border-radius: 15px;
width: 100%;
display: block;
margin: auto;
}

.help-text {
color: white !important;
}
</style>
